// extracted by mini-css-extract-plugin
export default {"page":"Registration_page__yfQWH","spacer":"Registration_spacer__mkt0D","heading":"Registration_heading__SGyyh"};